var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{attrs:{"name":_vm.name,"width":_vm.width,"height":_vm.height,"color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},[_c('circle',{staticClass:"a",attrs:{"cx":"12","cy":"12","r":"12"}})])}
var staticRenderFns = []

export { render, staticRenderFns }